import React, { useState } from "react";
import { ClipboardDocumentIcon, CheckIcon } from "@heroicons/react/24/outline";

interface JSONViewerProps {
  data: object | null | undefined;
  maxHeight?: string;
}

export const JSONViewer: React.FC<JSONViewerProps> = ({ data, maxHeight = "400px" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (data) {
      navigator.clipboard.writeText(JSON.stringify(data, null, 2));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (!data) {
    return (
      <div className="p-4 text-center text-muted-foreground text-sm">
        No raw data available
      </div>
    );
  }

  return (
    <div className="relative">
      {/* Copy Button */}
      <button
        onClick={handleCopy}
        className="absolute top-2 right-2 p-2 rounded bg-muted hover:bg-accent transition-colors z-10"
        title="Copy to clipboard"
      >
        {copied ? (
          <CheckIcon className="w-4 h-4 text-green-600" />
        ) : (
          <ClipboardDocumentIcon className="w-4 h-4 text-muted-foreground" />
        )}
      </button>

      {/* JSON Content */}
      <pre
        className="p-4 bg-muted rounded text-xs overflow-auto font-mono"
        style={{ maxHeight }}
      >
        <code className="text-foreground">
          {JSON.stringify(data, null, 2)}
        </code>
      </pre>
    </div>
  );
};
